var uiKit = {
  datepicker: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday_short: 'SU',
    monday_short: 'M',
    tuesday_short: 'T',
    wednesday_short: 'W',
    thursday_short: 'TH',
    friday_short: 'F',
    saturday_short: 'S',
    january: 'January',
    february: 'February',
    march: 'March',
    april: 'April',
    may: 'May',
    june: 'June',
    july: 'July',
    august: 'August',
    september: 'September',
    october: 'October',
    november: 'November',
    december: 'December',
    pick_year: 'Pick a year',
    pick_month: 'Pick a month',
    pick_date: 'Pick a date'
  }
};

export default {
  myaccount: {
    welcomeBar: {
      hi: 'Hi',
      lastLogin: 'Last Login',
      fullDate: '{{day}} {{month}} {{year}}, {{hour}}',
      months: {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        10: 'Oct',
        11: 'Nov',
        12: 'Dec'
      }
    },
    accountInfo: {
      id: 'ID'
    },
    navigationMenu: {
      title: {
        myBets: 'My Bets',
        accountHistory: 'My Transactions',
        withdraw: 'Withdraw',
        reversalWithdraw: 'Reverse Withdrawal',
        myRewards: 'Promotions',
        myAccount: 'Account Preferences',
        depositLimit: 'Deposit Limit',
        deposit: 'Deposit',
        gamblingControls: 'Gambling Controls',
        saferGambling: 'Safer Gambling',
        pokerBalanceTransfer: 'Poker Balance Transfer'
      }
    },
    profitAndLoss: {
      title: 'Profit and Loss',
      description: {
        up: 'You are {{value}} up this month',
        down: 'You are {{value}} down this month'
      },
      months: {
        Jan: 'January',
        Feb: 'February',
        Mar: 'March',
        Apr: 'April',
        May: 'May',
        Jun: 'June',
        Jul: 'July',
        Aug: 'August',
        Sep: 'September',
        Oct: 'October',
        Nov: 'November',
        Dec: 'December'
      }
    },
    sgHighlighedPanel: {
      text: "Let's keep on top of things. Learn <br>" + 'more about our Safer Gambling <br>' + ' Tools. {{linkText}}',
      linkText: 'Go to Safer Gambling Tools'
    },
    saferGamblingHighlighted: {
      text: "Let's keep on top of things. Use our safer gambling tools to help you play safely and read more about" + '  {{linkText}}',
      linkText: 'safer gambling'
    },
    accountButton: {
      gameActiveText: 'Game Active'
    },

    myAccountTitles: {
      title: {
        accountHistory: 'My Transactions',
        personalDetails: 'Personal Details',
        loginSecuritySettings: 'Login & Security Settings',
        siteSettings: 'Site Settings'
      },
      listItems: {
        statementsView: 'Statements View',
        summaries: 'Net Deposit Information',
        contactName: 'Contact Name',
        contactDetails: 'Contact Details',
        marketingPreferences: 'Marketing Preferences',
        autoLogin: 'Auto-login',
        twoFactorAuth: 'Two-factor auth',
        password: 'Password',
        oddsFormat: 'Odds format',
        movementPrices: 'Movement prices'
      }
    },

    saferGambling: {
      tilesConfig: {
        header: {
          text: 'Gambling should always be fun. So, we’ve created some useful tools to help you stay in control of how much you’re spending.'
        },

        footer: {
          text: 'Find out more about what we are doing to support ',
          link: 'Safer Gambling'
        },

        selfAssessment: {
          title: 'Self Assessment',
          description: 'Use this self assessment tool to help you keep track of your gambling habits. it will only take 2 minutes!',
          highlightedSectionText: 'Self Assessment'
        },
        depositLimits: {
          title: 'Deposit Limits',
          description: 'Set rolling daily, weekly or monthly limits on the maximum amount of money you can deposit in your account',
          highlightedSectionText: 'Deposit Limits'
        },
        gamingTimeReminder: {
          title: 'Gaming Time Reminders',
          description: 'Only available on gaming products. Set up notifications that tell you how long you’ve been gaming for.',
          highlightedSectionText: 'Session Time Reminder'
        },

        timeOut: {
          title: 'Time Out',
          descriptionUk: 'Take a break from gambling with us. It can be anything up to 42 days.',
          descriptionNonUk: 'Take a break from gambling with us. It can be anything up to 6 months.',
          highlightedSectionText: 'Take a Time Out'
        },

        accountClosure: {
          title: 'Account Closure',
          description: 'We will be sorry to see you go but if you wish to close your account you can do it here.'
        },

        selfExclusion: {
          title: 'Self Exclusion',
          description: 'Close your account for six months to five years.'
        },
        profitAndLoss: {
          title: 'Profit and Loss',
          description: {
            up: 'You are {{value}} up this month',
            down: 'You are {{value}} down this month'
          }
        }
      },

      views: {
        depositLimits: {
          day: 'day',
          week: 'week',
          month: 'month',
          viewHeader: {
            title: 'Set a deposit limit',
            content: 'Set daily, weekly or monthly limits on how much you can deposit.<br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/6755" rel="noopener noreferrer" target="_blank">How does that work?</a>'
          },
          limits: {
            daily: 'Daily limit',
            weekly: 'Weekly limit',
            monthly: 'Monthly limit'
          },
          periods: {
            day: 'daily',
            week: 'weekly',
            month: 'monthly'
          },
          buttonText: 'Save your deposit limits',
          chooseLimit: 'Choose limit',
          valueNotSet: 'Not set',
          noLimit: 'No limit',
          noLimitSet: 'No limit set',
          remainingDeposit: {
            day: 'You have {{amount}} left to deposit this day',
            week: 'You have {{amount}} left to deposit this week',
            month: 'You have {{amount}} left to deposit this month'
          },
          emptyRemainingDeposit: 'You have no deposit limits',
          successMessage: 'Deposit Limits updated successfully',
          confirmationButton: 'Confirm Limit Increase to {{amount}}',
          confirmationButtonNoLimit: 'Confirm Limit Increase to "no limit"',
          confirmationMessage: {
            day: 'Your daily limit of {{amount}} will be available to confirm on {{date}} at {{time}} (UK time).<br> <br>' + 'You can cancel this by <a href="#">clicking here</a>',
            week: 'Your weekly limit of {{amount}} will be available to confirm on {{date}} at {{time}} (UK time).<br> <br>' + 'You can cancel this by <a href="#">clicking here</a>',
            month: 'Your monthly limit of {{amount}} will be available to confirm on {{date}} at {{time}} (UK time).<br> <br>' + 'You can cancel this by <a href="#">clicking here</a>'
          },
          confirmationMessageNoLimit: {
            day: 'Your daily limit of "no limit" will be available to confirm on {{date}} at {{time}} (UK time).<br> <br>' + 'You can cancel this by <a href="#">clicking here</a>',
            week: 'Your weekly limit of "no limit" will be available to confirm on {{date}} at {{time}} (UK time).<br> <br>' + 'You can cancel this by <a href="#">clicking here</a>',
            month: 'Your monthly limit of "no limit" will be available to confirm on {{date}} at {{time}} (UK time).<br> <br>' + 'You can cancel this by <a href="#">clicking here</a>'
          },
          confirmationSuccessful: 'Deposit limit updated successfully',
          increaseWarning: 'You will need to confirm in 24 hours if you want to increase your limit.',
          footerContent: 'Don’t see the limit you wish to set?<br/>' + '<a href="https://williamhill-lang.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">Contact customer services</a>',
          cancellationModalContent: 'Are you sure you want to cancel your deposit limit increase?'
        },

        gamingTimeReminder: {
          accordionText: 'Gaming time reminder',
          currentReminder: 'Current Reminder: ',
          reminders: {
            placeholder: 'Select Time Period',
            noReminder: 'No Reminder',
            minutes: '{{time}} minutes',
            hour: '{{time}} hour',
            hours: '{{time}} hours'
          },
          submitButton: 'Save Your Reminder',
          warningMessage: 'Time reminder will take effect when your current session reminder is complete or active games closed.',
          successMessage: 'Gaming Time Reminders updated successfully',
          viewHeader: {
            title: 'Set a Gaming Time Reminder',
            content: '<p>Set an automated reminder letting you know how long you’ve been gaming for.</p><a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733/#3" rel="noopener noreferrer" target="_blank">How does this work?</a></br></br>' + '<p>This is only available for gaming products. Please note that gaming products do not include sports, poker, virtual or free play tournament. To set a reminder for Evolution Gaming content, launch a game, choose “Settings” and then “Game Session Settings”.</p>'
          },
          valueNotSet: 'Not set'
        },

        timeOut: {
          viewHeader: {
            title: 'Set a time out',
            contentUk: 'If you want to take a break from betting with us. We can set up a time out for up to 42 days.</br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733#4" rel="noopener noreferrer" target="_blank"> How does that work?</a>',
            contentNonUk: 'If you want to take a break from betting with us. We can set up a time out for up to 6 months.</br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733#4" rel="noopener noreferrer" target="_blank"> How does that work?</a>'
          },
          formLabel: 'How long do you need?',
          values: {
            placeholder: 'Select time out duration',
            day: '1 day',
            days: '{{amount}} days',
            valueNotSet: 'No time out'
          },
          formHeader: 'Close your account',
          passwordPlaceholder: 'Enter password',
          submitButton: 'Save your Time Out',
          viewFooter: 'If you wish to request a Time Out for more than 30 days please <a href="https://williamhill-lang.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">contact customer services</a>',
          resultPage: {
            title: 'Your Account is taking Time Out',
            information: 'You won’t be able to access your account for {{period}} day(s).',
            helpSectionMainText: 'To take a proper break, you should also remove any betting apps from your phone. More details can be found on our Safer Gambling help page.'
          }
        },

        accountClosure: {
          header: 'Yes, I want to close my account',
          listTitle: "Here's what you need to know:",
          firstListElement: 'If you want to take a break or close your account for Safer Gambling reasons please consider a <a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733#4" rel="noopener noreferrer" target="_blank">Time out</a> (up to 6 weeks) or a <a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733#5" rel="noopener noreferrer" target="_blank">Self exclusion</a> (up to five years)',
          secondListElement: 'Make sure to withdraw the remaining money in your account first',
          thirdListElement: 'Please note that we will keep your data for at least 5 years, please see our <a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/6721" rel="noopener noreferrer" target="_blank">Privacy Policy</a> for more information',
          formHeader: 'Close your account',
          closureReasonPlaceholder: 'Pick your reason',
          passwordPlaceholder: 'Enter password',
          submitButton: 'Close my account',
          reasons: {
            CLOSURE_REASON_OFFERS: 'I am not happy with your offers',
            CLOSURE_REASON_PRODUCTS: 'I am not happy with your products',
            CLOSURE_REASON_SERVICE: 'I am not happy with your service',
            CLOSURE_REASON_TIME: 'I do not have enough time to use my account anymore',
            CLOSURE_REASON_CHANGES: 'I do not like the changes you recently made',
            CLOSURE_REASON_PROVIDER: 'I now use another provider',
            CLOSURE_REASON_SECRET: 'I would prefer not to say'
          }
        },

        accountClosed: {
          title: 'Your account has been closed',
          text: 'To request a withdrawal<br>' + '<a href="https://williamhill-lang.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">Contact customer services</a><br><br>' + 'You can re-open your account at any time by going to our Account Recovery page.',
          helpSectionMainText: 'If you want to take a break or close your account for Safer Gambling reasons please consider a time out (up to 6 weeks) or a Self exclusion (up to five years).<br><br>' + ' More details can be found on our Safer Gambling help page.'
        },

        gamblingHelpSection: {
          bottomSectionTitle: 'More help',
          bottomSectionText: 'There are organisations that can help with free, independent advice on how to manage your gambling.',
          mainButtonText: 'Go to Safer Gambling',
          bottomSectionFirstButton: 'GamCare',
          bottomSectionSecondButton: 'Gamblers Anonymous',
          bottomSectionThirdButton: 'Gambling Therapy',
          gamstopHeader: 'GAMSTOP',
          gamstopContent: 'We strongly recommend you uninstall any mobile gambling apps from William Hill and other gambling providers. You can ask to be excluded from other gambling sites registered in Great Britain with GAMSTOP.',
          gamstopButton: 'Go to GAMSTOP'
        },

        selfExclusionSelection: {
          viewHeader: {
            title: 'Set a Self Exclusion',
            content: 'If you think you might have a problem and you want to stop yourself from gambling completely we recommend using GAMSTOP.<br /><br />GAMSTOP helps control your gambling by excluding you from licensed gambling sites and apps in Great Britain for a period of your choosing.<br /><br />You can set yourself a self exclusion for a minimum of 6 months and up to 5 years.'
          },
          gamstopButton: 'Go to GAMSTOP',
          selfExcludeFromWH: 'Self Exclude from William Hill'
        },

        selfExclusion: {
          viewHeader: {
            title: 'Set a Self Exclusion',
            content: 'You can exclude yourself from your account across all William Hill and affiliated sites for a minimum of 6 months and a maximum of 5 years.<br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/2733#5" rel="noopener noreferrer" target="_blank">How does that work?</a><br/><br/>'
          },
          upperSectionLabel: 'Are you sure you want to self exclude?',
          formLabel: 'How long do you need?',
          termsMessage: 'By asking to be excluded from William Hill you accept our {{termsMessageLink}}.<br /><br />' + 'You won’t be able to access your account for the time period you requested and you won’t be able to reopen it before then.',
          termsMessageLink: 'Terms & Conditions', // please notice this is a part of the previous key
          upperButton: 'Yes, I want to self exclude',
          period: {
            months: '{{amount}} months',
            year: '1 year',
            years: '{{amount}} years',
            valueNotSet: 'No self exclusion period',
            indefinite: 'Indefinite (min. 1 year)'
          },
          exclusionPeriodPlaceholder: 'Select exclusion period',
          passwordPlaceholder: 'Enter your password to confirm your identity',
          submitButton: 'Request a self exclusion',
          brandsNote: {
            text: 'Your exclusion agreement with William Hill <span style="font-weight: bold;">will not be</span> automatically applied to an account you may have with "888 Brands". So, if required you’ll need to set up a new agreement with them separately.',
            link888: 'Self Exclude from 888.com',
            link777: 'Self Exclude from 777.com'
          }
        },

        termsAndConditions: {
          text: 'This document confirms the voluntary arrangement reached between the customer and WHG (International) Limited, relating to the exclusion of the customer from its Internet and Telephone Betting operations. <br><br><br>' + "The customer requests that their account is closed and that he/she be refused betting and gaming activity via the WHG (International) Limited's telephone and internet betting or gaming operations for the chosen period, from the date of receipt of confirmation of the customer's request by WHG (International) Limited and that he/she is not allowed to modify, revoke, withdraw or rescind his/her self-exclusion prior to the expiry of this agreement.<br><br><br>" + "Note: Exclusion from internet operations will be by reference to account number and e-mail address and exclusion from telephone operations will be by reference to account number. We will also take reasonable steps to exclude use of the credit and debit card number(s) linked to the customer's accounts. We strongly recommend that customers delete/ uninstall all apps or downloads connected to William Hill from his/her devices.<br><br><br>" + 'At the end of the exclusion period, or anytime thereafter, he/she can review this exclusion with the Customer Services Manager and either renew it for another specified period or opt to resume gambling. On requesting not to extend the exclusion he/she will be subject to a further one day exclusion period before being given access to and use of their account.',
          button: 'I have read terms and conditions'
        },

        selfExcluded: {
          title: 'Your Account is now self excluded',
          subtitle: {
            months: 'You won’t be able to access your account for {{amount}} months.',
            year: 'You won’t be able to access your account for {{amount}} year.',
            years: 'You won’t be able to access your account for {{amount}} years.',
            indefinite: 'Your account is self excluded indefinitely, and you will not be able to access your account for a minimum of 1 year.'
          },
          helpSectionMainText: 'To take a proper break, remember to remove any other gambling sites or apps from your devices. Any remaining balance will be automatically refunded to you. To find out more, go to our Safer Gambling page.'
        },

        saferGamblingHighlighted: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque condimentum felis eu massa malesuada, sit amet accumsan nibh varius. Nunc sagittis tortor sagittis posuere convallis. Cras luctus, turpis ac ultrices vehicula, sem orci faucibus orci, interdum suscipit metus orci ut metus.'
        },

        divider: {
          or: 'or'
        }
      },

      valueNotSet: 'Not set',
      incorrectPasswordErrorMessage: 'Your password does not match',
      genericError: 'Sorry it has not been possible to complete your request. Please try again or contact Customer Services for assistance.'
    },

    header: {
      error: {
        message: 'Could not fetch your data',
        retry: 'Retry'
      },
      title: {
        saferGambling: 'Safer Gambling Tools',
        depositLimitsPage: 'Deposit Limits',
        gamingTimeReminderPage: 'Gaming Time Reminders',
        accountNetDeposit: 'Net Deposit Information',
        landing: 'My Account',
        myAccount: 'Account Preferences',
        myBets: 'My Bets',
        personalDetails: 'Personal Details',
        siteSettings: 'Site Settings',
        accountHistory: 'My Transactions',
        loginSecurity: 'Login & Security',
        summaryExport: 'Summary export',
        accountClosure: 'Account Closure',
        accountClosed: 'Account Closure',
        timeOutResult: 'Time Out',
        deposit: 'Deposit',
        timeOut: 'Time Out',
        termsAndConditions: 'Self Exclusion',
        selfExclusionSelectionPage: 'Self Exclusion',
        selfExclusionPage: 'Self Exclusion',
        selfExcluded: 'Self Exclusion',
        bonusLanding: 'Balance Information'
      }
    },
    balanceAndBonus: {
      cashBalance: 'Cash Balance',
      additionalBalance: { sportsbook: 'Free Bets', gaming: 'Gaming Bonus', poker: 'Poker bonus' },
      balanceInfoLink: 'Balance Information'
    },

    bonusLanding: {
      withdrawable: {
        title: 'Withdrawable Balance',
        balances: {
          mainCashBalance: { mainText: 'Cash Balance', helperText: 'Can be used anywhere except poker' }, //@deprecated, use sportsbook key instead
          pokerCashBalance: { mainText: 'Poker Cash Balance', helperText: 'To be used on Poker only' }, //@deprecated, use poker key instead
          sportsbook: { mainText: 'Cash Balance', helperText: 'Can be used anywhere except poker' },
          poker: { mainText: 'Poker Cash Balance', helperText: 'To be used on Poker only' }
        }
      },
      bonus: {
        title: 'Bonus Balances',
        balances: {
          gaming: {
            mainText: 'Gaming',
            helperText: 'Bonus money for Gaming',
            buyInBalance: {
              mainText: 'Buy-in Balance',
              helperText: 'Cash balance committed to bonuses'
            },
            bonusBalance: {
              mainText: 'Bonus Balance',
              helperText: 'Bonus and pending winning balance'
            }
          },
          sportsbook: {
            mainText: 'Sports Free Bets',
            helperText: 'Free Bet money for Sports betting'
          },
          bingo: { mainText: 'Bingo', helperText: 'Bonus money for Bingo' },
          poker: { mainText: 'Poker', helperText: 'Bonus money for Poker' }
        }
      },
      footerText: {
        gaming: 'Check out our promotions to see what other gaming bonuses are available',
        sportsbook: 'Check out our promotions to see what other bonuses are available'
      },
      buttonText: { gaming: 'View Gaming Promotions', sportsbook: 'View Promotions' }
    },

    transactions: {
      reference: 'Ref No.',
      aamsId: 'ID AAMS:',
      EW: 'EW',
      eachWay: 'EW 1-{{places}} Places, {{price}} Odds',
      stake: 'Stake',
      refund: 'Refund',
      return: 'Return',
      bonusStake: 'Bonus stake',
      stakeTotal: 'Total Stake',
      tab: {
        summary: 'Summary',
        history: 'Transactions'
      },
      myBets: {
        open: 'Open',
        settled: 'Settled'
      },
      numberOfLines: 'x {{value}} Bets',
      price: {
        '@ SP': '@ SP',
        '@ Guaranteed Price': '@ Guaranteed Price ({{price}})'
      },
      accountNetDeposit: {
        buttonLabel: 'See Your',
        buttonTitle: 'Net Deposit Information'
      },
      lotteryBet: {
        draw: 'Draw:',
        result: 'Result:'
      },
      totePoolBetting: 'Pool Betting',
      bettingTerminal: 'Betting Terminal',
      type: {
        BET_ACCUMULATOR_10: 'Accumulator (10)',
        BET_ACCUMULATOR_11: 'Accumulator (11)',
        BET_ACCUMULATOR_12: 'Accumulator (12)',
        BET_ACCUMULATOR_13: 'Accumulator (13)',
        BET_ACCUMULATOR_14: 'Accumulator (14)',
        BET_ACCUMULATOR_15: 'Accumulator (15)',
        BET_ACCUMULATOR_16: 'Accumulator (16)',
        BET_ACCUMULATOR_17: 'Accumulator (17)',
        BET_ACCUMULATOR_18: 'Accumulator (18)',
        BET_ACCUMULATOR_19: 'Accumulator (19)',
        BET_ACCUMULATOR_20: 'Accumulator (20)',
        BET_ACCUMULATOR_21: 'Accumulator (21)',
        BET_ACCUMULATOR_22: 'Accumulator (22)',
        BET_ACCUMULATOR_23: 'Accumulator (23)',
        BET_ACCUMULATOR_24: 'Accumulator (24)',
        BET_ACCUMULATOR_25: 'Accumulator (25)',
        BET_ACCUMULATOR_4: 'Fourfold(s)',
        BET_ACCUMULATOR_5: 'Fivefold(s)',
        BET_ACCUMULATOR_6: 'Sixfold(s)',
        BET_ACCUMULATOR_7: 'Sevenfold(s)',
        BET_ACCUMULATOR_8: 'Eightold(s)',
        BET_ACCUMULATOR_9: 'Ninefold(s)',
        BET_CANADIAN: 'Canadian',
        BET_DDB: 'Tote - Daily Double',
        BET_DOUBLE: 'Double(s)',
        BET_DOUBLES: 'Doubles',
        BET_EIGHTFOLDS: 'Eightfolds',
        BET_EXA: 'Tote - Exacta',
        BET_FIVEFOLDS: 'Fivefolds',
        BET_FLG: 'Flag',
        BET_FOURFOLDS: 'Fourfolds',
        BET_GOLIATH: 'Goliath',
        BET_HEINZ: 'Heinz',
        BET_LUCKY_15: 'Lucky 15',
        BET_LUCKY_31: 'Lucky 31',
        BET_LUCKY_63: 'Lucky 63',
        BET_MAN: 'Written Bet',
        BET_NINEFOLDS: 'Ninefolds',
        BET_PATENT: 'Patent',
        BET_PK3: 'Tote - Pick 3',
        BET_PK4: 'Tote - Pick 4',
        BET_PK6: 'Tote - Pick 6',
        BET_PK9: 'Tote - Pick 9',
        BET_PLC: 'Tote - Place',
        BET_QIN: 'Tote - Quinella',
        BET_ROB: 'Round Robin',
        BET_SEVENFOLDS: 'Sevenfolds',
        BET_SHW: 'Tote - Show',
        BET_SINGLE: 'Single',
        BET_SIXFOLDS: 'Sixfolds',
        BET_SPR: 'Tote - Superfecta',
        BET_SUPER_HEINZ: 'Super Heinz',
        BET_TENFOLDS: 'Tenfolds',
        BET_TREBLE: 'Treble(s)',
        BET_TREBLES: 'Trebles',
        BET_TRI: 'Tote - Trifecta',
        BET_TRIXIE: 'Trixie',
        BET_UEXA: 'Tote - Exacta',
        BET_UJKP: 'Tote - Jackpot',
        BET_UKN: 'Bet',
        BET_UPLC: 'Tote - Place',
        BET_UPLP: 'Tote - Placepot',
        BET_UQDP: 'Tote - Quadpot',
        BET_USC6: 'Tote - Scoop 6',
        BET_USC7: 'Tote - Super7',
        BET_USW: 'Tote - Swinger',
        BET_UTD: 'Tote - Double',
        BET_UTRI: 'Tote - Trifecta',
        BET_UTT: 'Tote - Treble',
        BET_UWIN: 'Tote - Win',
        BET_WIN: 'Tote - Win',
        BET_YANKEE: 'Yankee',
        BONUS: 'Balance adjustment',
        DEPOSIT: 'Deposit',
        PRIORITY_CARD_CASH: 'Cash',
        PRIORITY_CARD_CASHBACK: 'Purchase with cashback',
        PRIORITY_CARD_DEPOSIT: 'Deposit',
        PRIORITY_CARD_NON_CASH: 'Non-cash',
        PRIORITY_CARD_OTHER: 'Other',
        PRIORITY_CARD_PURCHASE: 'Purchase',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-cash',
        PRIORITY_CARD_REFUND: 'Refund',
        PRIORITY_CARD_TRANSACTION: 'Payment',
        REVERSAL: 'Reversal',
        MANUAL_ADJUSTMENT: 'Manual Adjustment',
        WITHDRAWAL: 'Withdrawal',
        TRANSFER: 'Transfer',
        CASINO: 'Casino',
        SLOTS: 'Slots',
        VEGAS: 'Vegas',
        GAMES: 'Games',
        GAMING: 'Gaming',
        POKER: 'Poker',
        BINGO: 'Bingo',
        LIVE_CASINO: 'Live Casino'
      },
      manualAdjustmentType: {
        AFFP: 'Affiliate Payments',
        AFFR: 'Affiliate Rakeback',
        BCNV: 'Balance Conversion',
        BETC: 'Bet Correction',
        BNJW: 'Jackpot Wins',
        BNKC: 'Bank Charges',
        BONS: 'Manual Bonus',
        BPCS: 'Bonus Payment (cs)',
        BTCS: 'Balance Transfer (cs)',
        CADJ: 'Commission Adjustment',
        CSH: 'Cash Adjustments',
        CWIN: 'Cut Winnings',
        GWCS: 'Gesture of Goodwill (cs)',
        GWIL: 'Gesture of Goodwill',
        HEDG: 'Hedging',
        INAC: 'Inactivity Charge',
        ISCS: 'Incorrect Settlement (cs)',
        LFND: 'Lost / Trapped Funds',
        MCM: 'Manual Cash Movement',
        ONCR: 'On-Course',
        PGCW: 'Pre GC Write Off',
        RCHQ: 'Return Cheque',
        SCHQ: 'Stop Cheque',
        TFCS: 'Trapped Funds (cs)',
        WOFF: 'Write Off'
      },
      result: {
        WIN: 'Win',
        LOST: 'Loss',
        VOIDED: 'Voided',
        CASHED_IN: 'Cashed out',
        STAKE: 'Stake',
        CANCELED: 'Canceled',
        PLACED: 'Placed'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: 'Bank Transfer',
        CARD: 'Credit/Debit Card',
        CHEQUE: 'Cheque',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: 'Direct Bank Transfer',
        ECOPAYZ: 'EcoPayz',
        ENTROPAY: 'Entropay',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        NETELLER: 'Neteller',
        OTHER: 'Other',
        PAYPAL: 'PayPal',
        PAYSAFECARD: 'Paysafe Card',
        PINGIT: 'Pingit',
        PLUS: 'Plus Card',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter'
      },
      sort: {
        ANYTIME_SCORECAST: 'Anytime Scorecast',
        ANYTIME_WINCAST: 'Anytime Wincast',
        ASIAN_HANDICAP: 'Asian Handicap',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'Combination First Four',
        COMBINATION_FORECAST: 'Combination Forecast',
        COMBINATION_QUINELLA: 'Combination Quinella',
        COMBINATION_TRICAST: 'Combination Tricast',
        CONTINUOUS_WIN: 'Continuous Win',
        FIRST_FOUR: 'First Four',
        FIRST_HALF_ASIAN_HANDICAP: '1st Half Asian Handicap',
        FIRST_HALF_OUTRIGHT: '1st Half Outright',
        FIRST_HALF_WESTERN_HANDICAP: '1st Half Western Handicap',
        FIRST_WINCAST: 'First Wincast',
        FORECAST: 'Forecast',
        HIGHER_LOWER: 'Higher/Lower',
        HIGHER_LOWER_SPLIT_OFFER: 'Higher/Lower (with split offer)',
        INSURED_SCORECAST: 'Insured Scorecast',
        INSURED_WINCAST: 'Insured Wincast',
        LAST_SCORECAST: 'Last Scorecast',
        LAST_WINCAST: 'Last Wincast',
        MATCH_HANDICAP: 'Match Handicap',
        OVER_UNDER: 'Over/Under',
        PERMED_FORECAST: 'Permed Forecast',
        PERMED_TRICAST: 'Permed Tricast',
        POINTS_MARKET: 'Points Market',
        QUINELLA: 'Quinella',
        REVERSE_FORECAST: 'Reverse Forecast',
        SCORECAST: 'Scorecast',
        SECOND_HALF_ASIAN_HANDICAP: '2nd Half Asian Handicap',
        SECOND_HALF_OUTRIGHT: '2nd Half Outright',
        SECOND_HALF_WESTERN_HANDICAP: '2nd Half Western Handicap',
        SIMPLE: 'Simple',
        STANDOUT_FIRST_FOUR: 'Standout First Four',
        STANDOUT_FORECAST: 'Standout Forecast',
        STANDOUT_QUINELLA: 'Standout Quinella',
        STANDOUT_TRICAST: 'Standout Tricast',
        STRAIGHT_FORECAST: 'Straight Forecast',
        TRICAST: 'Tricast',
        TRICAST_OPTIONS: 'Tricast Options',
        WESTERN_HANDICAP: 'Western (straight) Handicap',
        XTH_SCORER_SCORECAST: 'Xth Scorer Scorecast',
        XTH_SCORER_WINCAST: 'Xth Scorer Wincast'
      },
      boostedBet: 'Boosted Bet',
      loadMore: 'Load more',
      noTransactions: 'No transactions',
      accountSummary: {
        buttonLabel: 'Download your',
        buttonTitle: 'Summary export'
      },
      resetFilters: {
        filtersApplied: 'Applied filters',
        removeFilters: 'Remove All'
      },
      summary: {
        correctAsOfMidnight: 'Correct as of midnight',
        lastRefresh: '{{day}} {{month}} {{year}}',
        profitLoss: 'Profit and Loss',
        sports: 'Sports Betting',
        gaming: 'Gaming',
        profitLossBreakdown: 'Profit and Loss Breakdown',
        winsLosses: 'Wins - Losses',
        netDeposit: 'Net Deposit',
        netDepositLastRefresh: '{{day}} {{month}}',
        netDepositRefreshDate: 'Last updated: {{date}} at {{hour}}',
        lifetimeNetDeposit: 'Lifetime Net Deposit',
        totalDepositsWithdrawals: 'Total Withdrawals - Total Deposits',
        netDepositAvailableFrom: 'Information only available from 06/12/2008',
        saferGamblingNote: {
          title: 'Are you gambling safely?',
          description: 'Make sure you’re keeping gambling fun & spending what you can afford. If you need some help with this check out our {{link}}.',
          link: 'safer gambling tools'
        }
      }
    },
    filters: {
      dropdown: {
        transactionsSummary: {
          date: 'Month to date',
          filters: 'Filters'
        },
        transactionsHistory: {
          date: 'Last 7 days',
          filters: 'Filters'
        }
      },
      customDateRange: {
        toLabel: 'to',
        labels: {
          from: 'from',
          to: 'to'
        },
        error: 'Please select a valid date range or alternatively select a different date option',
        historyLimitation: {
          caption: 'Please note, transactions older than 1 year may not be \
available. If you wish to view these transactions, please contact ',
          link: 'customer services'
        }
      },
      predefinedDateRange: {
        sectionName: 'Predefined date range',
        allDates: 'All dates',
        last7: 'Last 7 days',
        last14: 'Last 14 days',
        last30: 'Last 30 days',
        custom: 'Custom Range'
      },
      transactionsSummaryDateRange: {
        sectionName: 'Select date range',
        monthToDate: 'Month to date',
        last7days: 'Last 7 days',
        last12months: 'Last 12 months'
      },
      view: {
        sectionName: 'View',
        all: 'All',
        onlyPayments: 'Only Payments',
        excludePayments: 'Exclude Payments',
        onlyWins: 'Only Wins',
        onlyLosses: 'Only Losses'
      },
      showHideBetTypes: {
        sectionName: 'Show / Hide Bets',
        singles: 'Singles',
        multiples: 'Multiples'
      },
      tabs: {
        all: 'All',
        sports: 'Sports',
        gaming: 'Gaming'
      },
      applyFilters: 'Apply'
    },
    footer: {
      button: {
        logout: {
          text: 'Logout'
        }
      },
      link: {
        feedback: 'Feedback',
        help: 'Help'
      }
    },
    autoAccept: {
      note: 'Auto Accept movement of prices',
      error: {
        save: 'Sorry, your changes cannot be saved at the moment. Please try again.'
      }
    },
    oddsFormat: {
      title: 'Odds Format',
      decimal: 'Decimal',
      fractional: 'Fractional'
    },
    accountSummary: {
      headerTitle: 'Select summaries to download',
      reportTitle: 'Annual Account Summary',
      exportToPDF: 'Export to PDF'
    },
    personalDetails: {
      tabs: {
        contact: 'Contact',
        marketing: 'Marketing'
      }
    },
    personalDetailsContact: {
      securityMessage: {
        title: 'At William Hill we take the security and privacy of your account seriously.',
        text: 'We hold your contact details in a secure location, including your name, postal address, phone number \
& email. To update your details please fill out the below fields and press ‘Update my details’. \
The updated details will be stored on our systems, but will not be displayed on the page.'
      },
      statusMessage: {
        success: 'Personal Details updated Successfully',
        failure: 'Something went wrong'
      },
      fields: {
        email: {
          label: 'Email'
        },
        addressLine1: {
          label: 'Address Line 1'
        },
        addressLine2: {
          label: 'Address Line 2'
        },
        addressCity: {
          label: 'City'
        },
        addressCounty: {
          label: 'County/State (optional)'
        },
        addressPostcode: {
          label: 'Postcode/ZIP'
        },
        country: {
          label: 'Country',
          defaultValue: 'Please select from the list.'
        },
        mobile: {
          label: 'Mobile Number'
        }
      },
      buttons: {
        submit: 'Update my details'
      },
      validationRules: {
        email: {
          required: 'The email address cannot be blank',
          maxLength: 'Too long. 60 characters maximum',
          email: 'Must be a valid email address'
        },
        street1: {
          required: 'The address is a mandatory field',
          maxLength: 'Too long. 160 characters maximum',
          pattern: 'Invalid character'
        },
        street2: {
          required: 'The address is a mandatory field',
          maxLength: 'Too long. 160 characters maximum',
          pattern: 'Invalid character'
        },
        city: {
          required: 'The city is a mandatory field',
          pattern: 'Invalid character',
          maxLength: 'Too long. 60 characters maximum'
        },
        county: {
          pattern: 'Invalid character',
          maxLength: 'Too long. 60 characters maximum'
        },
        postcode: {
          required: 'Postcode/Zip is required',
          pattern: 'Invalid character',
          maxLength: 'Too long. 12 characters maximum'
        },
        mobile: {
          required: 'The phone number cannot be blank',
          pattern: 'Invalid character Only numbers are accepted',
          minLength: 'Too short. Min 6 characters',
          maxLength: 'Too long. 20 characters maximum'
        }
      }
    },
    personalDetailsTimezone: {
      statusMessage: {
        success: 'Time zone updated successfully',
        failure: 'Something went wrong'
      },
      buttons: {
        updateTimezone: 'Update time zone'
      },
      fields: {
        timezones: {
          label: 'Time zone',
          values: {
            TIMEZONE_AFRICA_ADDIS_ABABA: 'Africa/Addis_Ababa',
            TIMEZONE_AFRICA_JOHANNESBURG: 'Africa/Johannesburg',
            TIMEZONE_AMERICA_ANCHORAGE: 'America/Anchorage',
            TIMEZONE_AMERICA_ARGENTINA_BUENOS_AIRES: 'America/Argentina/Buenos_Aires',
            TIMEZONE_AMERICA_CHICAGO: 'America/Chicago',
            TIMEZONE_AMERICA_DENVER: 'America/Denver',
            TIMEZONE_AMERICA_LOS_ANGELES: 'America/Los_Angeles',
            TIMEZONE_AMERICA_NEW_YORK: 'America/New_York',
            TIMEZONE_AMERICA_SAO_PAULO: 'America/Sao_Paulo',
            TIMEZONE_AMERICA_TORONTO: 'America/Toronto',
            TIMEZONE_AMERICA_VANCOUVER: 'America/Vancouver',
            TIMEZONE_ASIA_BANGKOK: 'Asia/Bangkok',
            TIMEZONE_ASIA_DHAKA: 'Asia/Dhaka',
            TIMEZONE_ASIA_DUBAI: 'Asia/Dubai',
            TIMEZONE_ASIA_HONG_KONG: 'Asia/Hong_Kong',
            TIMEZONE_ASIA_JERUSALEM: 'Asia/Jerusalem',
            TIMEZONE_ASIA_KARACHI: 'Asia/Karachi',
            TIMEZONE_ASIA_KOLKATA: 'Asia/Kolkata',
            TIMEZONE_ASIA_RANGOON: 'Asia/Rangoon',
            TIMEZONE_ASIA_SINGAPORE: 'Asia/Singapore',
            TIMEZONE_ASIA_TOKYO: 'Asia/Tokyo',
            TIMEZONE_ATLANTIC_AZORES: 'Atlantic/Azores',
            TIMEZONE_ATLANTIC_BERMUDA: 'Atlantic/Bermuda',
            TIMEZONE_AUSTRALIA_ADELAIDE: 'Australia/Adelaide',
            TIMEZONE_AUSTRALIA_PERTH: 'Australia/Perth',
            TIMEZONE_AUSTRALIA_SYDNEY: 'Australia/Sydney',
            TIMEZONE_EUROPE_ATHENS: 'Europe/Athens',
            TIMEZONE_EUROPE_BERLIN: 'Europe/Berlin',
            TIMEZONE_EUROPE_DUBLIN: 'Europe/Dublin',
            TIMEZONE_EUROPE_GIBRALTAR: 'Europe/Gibraltar',
            TIMEZONE_EUROPE_KIEV: 'Europe/Kiev',
            TIMEZONE_EUROPE_LONDON: 'Europe/London',
            TIMEZONE_EUROPE_MADRID: 'Europe/Madrid',
            TIMEZONE_EUROPE_MOSCOW: 'Europe/Moscow',
            TIMEZONE_EUROPE_PARIS: 'Europe/Paris',
            TIMEZONE_EUROPE_ROME: 'Europe/Rome',
            TIMEZONE_EUROPE_SOFIA: 'Europe/Sofia',
            TIMEZONE_EUROPE_VIENNA: 'Europe/Vienna',
            TIMEZONE_EUROPE_WARSAW: 'Europe/Warsaw',
            TIMEZONE_INDIAN_CHRISTMAS: 'Indian/Christmas',
            TIMEZONE_PACIFIC_AUCKLAND: 'Pacific/Auckland',
            TIMEZONE_PACIFIC_GUADALCANAL: 'Pacific/Guadalcanal',
            TIMEZONE_PACIFIC_HONOLULU: 'Pacific/Honolulu',
            TIMEZONE_PACIFIC_MIDWAY: 'Pacific/Midway'
          }
        }
      },
      validationRules: {
        required: 'Select time zone'
      }
    },
    personalDetailsMarketing: {
      mainNote: 'I want to receive news about bonuses, offers and services via email, SMS or telephone. \
You can update/edit your preferences at any time.',
      contactMethodLabel: {
        telephone: 'Call',
        email: 'Email',
        sms: 'SMS'
      },
      error: {
        save: 'Sorry, your data cannot be saved at the moment. Please try again.'
      },
      disclaimer: {
        text: 'Disclaimer: ',
        note: 'Please note that it can take up to 48 hours for changes to be applied. \
We use push notifications as part of our services. You can control your push notification settings \
on your device. If you use more than one device to access the service \
you will need to adjust your settings on each device.'
      }
    },
    loginSecurity: {
      changePassword: 'Change password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      savePassword: 'Save New Password',
      passwordUpdated: 'Your password has been updated',
      genericErrorMessage: 'Something went wrong',
      validationRules: {
        currentPassword: {
          required: 'Current password field is empty',
          invalidCredentials: 'Wrong Password'
        },
        newPassword: {
          required: 'New password field is empty',
          minLength: 'New password is less than 8 or more than 15 symbols',
          maxLength: 'New password is less than 8 or more than 15 symbols',
          forbiddenChars: 'Password cannot contain the following characters: ; \' " \\ ? # ~ ; : + = ( ) & %',
          allowedChars: 'Password cannot contain the following characters: ; \' " \\ ? # ~ ; : + = ( ) & %',
          forbiddenWords: 'The inserted password is too vulnerable. Please choose another one.',
          hasDigit: "New password doesn't include each of the following: one number, one small letter and one caps",
          hasUppercaseLetter: "New password doesn't include each of the following: one number, one small letter and one caps",
          pattern: 'Password must have a minimum of 8 characters and contain at least one letter, number and symbol (!#%&()*+,-./:<=>?@^_`|~).',
          cannotContainFirstName: 'Password cannot contain your name.',
          cannotContainLastName: 'Password cannot contain your surname name.',
          cannotContainUsername: 'Password cannot contain your username.',
          cannotContainDateOfBirth: 'Password cannot contain your date of birth.',
          cannotBeEqualToLastPassword: 'New password cannot be equal to last password'
        },
        infoLabel: 'Choose a password safe and easy to remember.',
        genericRules: 'Use 8 to 15 characters. Must contain at least one letter, number and symbol (!#%&()*+,./:<=>?@^_`|~) are allowed. Capitalisation matters. No spaces allowed.'
      }
    },
    accountNetDeposit: {
      title: 'Account lifetime Net deposit',
      description: 'The net deposit amount shows the sum of all transactions for your account (withdrawals minus deposits).',
      accessNote: 'Please note we can only access account information from 6/12/2008',
      timePeriod: {
        title: 'Time period Net deposit',
        description: 'The net deposit for the selected time period. All time periods begin from previous full day. We will send this information to your registered email address within 24 hours.',
        optionsTitle: 'Choose a period',
        optionLabels: {
          LAST_DAY: 'Previous day',
          LAST_WEEK: 'Previous 7 days',
          LAST_MONTH: 'Previous 30 days'
        },
        success: 'We will send this information to your registered email address within 24 hours',
        requestDeposit: 'Email me selected Net deposit'
      },
      lifetimeNetDepositButton: 'View account lifetime net deposit'
    },
    depositLimit: {
      pendingRequestText: 'You request to increase {{limitLabel}} to {{requestAmount}} \
will start effective from {{requestEffectiveFrom}}.',
      contactCustomerService: 'As you have limit increase request in process you cannot change your current limits online. \
If you want to change them please contact our customer service by clicking ',
      customerServiceLink: 'here'
    },
    error: {
      network: {
        text: 'A network error occurred',
        subText: 'Please try again in a few moments.',
        retrySubText: 'Please re-open My Account in a few moments.'
      },
      graphQL: {
        text: 'Oops we could not get requested data.',
        subText: 'Please try again in a few moments.',
        retrySubText: 'Please re-open My Account in a few moments.'
      },
      retry: 'Retry',
      iconAlt: 'Traffic Cone',
      genericRequest: 'Sorry it has not been possible to complete your request. Please try again or contact Customer Services for assistance.'
    },
    loginPreferences: {
      title: 'Login preference',
      options: {
        pin: 'Pin',
        faceID: 'Use faceID',
        touchID: 'Use touchID',
        none: "Don't save login details",
        autoLogin: 'Auto-login',
        rememberUserName: 'Remember username'
      },
      error: {
        save: 'Sorry, your data cannot be saved at the moment. Please try again.'
      }
    },
    confirmationModal: {
      confirmationText: 'Yes',
      cancellationText: 'No'
    }
  },
  countries: {
    COUNTRY_AD: 'Andorra',
    COUNTRY_AE: 'United Arab Emirates',
    COUNTRY_AF: 'Afghanistan',
    COUNTRY_AG: 'Antigua And Barbuda',
    COUNTRY_AI: 'Anguilla',
    COUNTRY_AL: 'Albania',
    COUNTRY_AM: 'Armenia',
    COUNTRY_AN: 'Netherlands Antilles',
    COUNTRY_AO: 'Angola',
    COUNTRY_AQ: 'Antarctica',
    COUNTRY_AR: 'Argentina',
    COUNTRY_AS: 'American Samoa',
    COUNTRY_AT: 'Austria',
    COUNTRY_AU: 'Australia',
    COUNTRY_AW: 'Aruba',
    COUNTRY_AX: 'Aland Islands',
    COUNTRY_AZ: 'Azerbaijan',
    COUNTRY_BA: 'Bosnia and Herzegovina',
    COUNTRY_BB: 'Barbados',
    COUNTRY_BC: 'British Columbia',
    COUNTRY_BD: 'Bangladesh',
    COUNTRY_BE: 'Belgium',
    COUNTRY_BF: 'Burkina Faso',
    COUNTRY_BG: 'Bulgaria',
    COUNTRY_BH: 'Bahrain',
    COUNTRY_BI: 'Burundi',
    COUNTRY_BJ: 'Benin',
    COUNTRY_BM: 'Bermuda',
    COUNTRY_BN: 'Brunei Darussalam',
    COUNTRY_BO: 'Bolivia',
    COUNTRY_BP: 'Bophuthatswana',
    COUNTRY_BR: 'Brazil',
    COUNTRY_BS: 'Bahamas',
    COUNTRY_BT: 'Bhutan',
    COUNTRY_BV: 'Bouvet Island',
    COUNTRY_BW: 'Botswana',
    COUNTRY_BY: 'Belarus',
    COUNTRY_BZ: 'Belize',
    COUNTRY_CA: 'Canada',
    COUNTRY_CC: 'Cocos (Keeling) Islands',
    COUNTRY_CD: 'Republic of Congo',
    COUNTRY_CF: 'Central African Republic',
    COUNTRY_CG: 'Congo, Democratic Republic of',
    COUNTRY_CH: 'Switzerland',
    COUNTRY_CI: 'Ivory Coast',
    COUNTRY_CK: 'Cook Islands',
    COUNTRY_CL: 'Chile',
    COUNTRY_CM: 'Cameroon',
    COUNTRY_CN: 'China PR',
    COUNTRY_CO: 'Colombia',
    COUNTRY_CR: 'Costa Rica',
    COUNTRY_CU: 'Cuba',
    COUNTRY_CV: 'Cape Verde Islands',
    COUNTRY_CX: 'Christmas Island',
    COUNTRY_CY: 'Cyprus',
    COUNTRY_CZ: 'Czech Republic',
    COUNTRY_DE: 'Germany',
    COUNTRY_DJ: 'Djibouti',
    COUNTRY_DK: 'Denmark',
    COUNTRY_DM: 'Dominica',
    COUNTRY_DO: 'Dominican Republic',
    COUNTRY_DZ: 'Algeria',
    COUNTRY_EC: 'Ecuador',
    COUNTRY_EE: 'Estonia',
    COUNTRY_EG: 'Egypt',
    COUNTRY_EH: 'Western Sahara',
    COUNTRY_ER: 'Eritrea',
    COUNTRY_ES: 'Spain',
    COUNTRY_ET: 'Ethiopia',
    COUNTRY_EU: 'European Union',
    COUNTRY_FI: 'Finland',
    COUNTRY_FJ: 'Fiji',
    COUNTRY_FK: 'Falkland Islands',
    COUNTRY_FM: 'Micronesia',
    COUNTRY_FO: 'Faroe Islands',
    COUNTRY_FR: 'France',
    COUNTRY_FX: 'Metropolitan France',
    COUNTRY_GA: 'Gabon',
    COUNTRY_GD: 'Grenada',
    COUNTRY_GE: 'Georgia',
    COUNTRY_GF: 'French Guyana',
    COUNTRY_GG: 'Guernsey',
    COUNTRY_GH: 'Ghana',
    COUNTRY_GI: 'Gibraltar',
    COUNTRY_GL: 'Greenland',
    COUNTRY_GM: 'Gambia',
    COUNTRY_GN: 'Guinea',
    COUNTRY_GP: 'Guadeloupe',
    COUNTRY_GQ: 'Equatorial Guinea',
    COUNTRY_GR: 'Greece',
    COUNTRY_GS: 'South Georgia',
    COUNTRY_GT: 'Guatemala',
    COUNTRY_GU: 'Guam',
    COUNTRY_GW: 'Guinea-Bissau',
    COUNTRY_GY: 'Guyana',
    COUNTRY_HK: 'Hong Kong',
    COUNTRY_HM: 'Heard and McDonald Islands',
    COUNTRY_HN: 'Honduras',
    COUNTRY_HR: 'Croatia',
    COUNTRY_HT: 'Haiti',
    COUNTRY_HU: 'Hungary',
    COUNTRY_ID: 'Indonesia',
    COUNTRY_IE: 'Ireland (Rep. of)',
    COUNTRY_IL: 'Israel',
    COUNTRY_IM: 'Isle of Man',
    COUNTRY_IN: 'India',
    COUNTRY_IO: 'British Indian Ocean Territory',
    COUNTRY_IQ: 'Iraq',
    COUNTRY_IR: 'Iran',
    COUNTRY_IS: 'Iceland',
    COUNTRY_IT: 'Italy',
    COUNTRY_JE: 'Jersey',
    COUNTRY_JM: 'Jamaica',
    COUNTRY_JO: 'Jordan',
    COUNTRY_JP: 'Japan',
    COUNTRY_KE: 'Kenya',
    COUNTRY_KG: 'Kyrgyzstan',
    COUNTRY_KH: 'Cambodia',
    COUNTRY_KI: 'Kiribati',
    COUNTRY_KM: 'Comoros',
    COUNTRY_KN: 'Saint Kitts And Nevis',
    COUNTRY_KP: 'Korea (North)',
    COUNTRY_KR: 'Korea (South)',
    COUNTRY_KW: 'Kuwait',
    COUNTRY_KY: 'Cayman Islands',
    COUNTRY_KZ: 'Kazakhstan',
    COUNTRY_LA: 'Laos',
    COUNTRY_LB: 'Lebanon',
    COUNTRY_LC: 'Saint Lucia',
    COUNTRY_LI: 'Liechtenstein',
    COUNTRY_LK: 'Sri Lanka',
    COUNTRY_LR: 'Liberia',
    COUNTRY_LS: 'Lesotho',
    COUNTRY_LT: 'Lithuania',
    COUNTRY_LU: 'Luxembourg',
    COUNTRY_LV: 'Latvia',
    COUNTRY_LY: 'Libya',
    COUNTRY_MA: 'Morocco',
    COUNTRY_MC: 'Monaco',
    COUNTRY_MD: 'Moldova',
    COUNTRY_ME: 'Montenegro',
    COUNTRY_MG: 'Madagascar',
    COUNTRY_MH: 'Marshall Islands',
    COUNTRY_MK: 'F.Y. Rep of Macedonia',
    COUNTRY_ML: 'Mali',
    COUNTRY_MM: 'Myanmar',
    COUNTRY_MN: 'Mongolia',
    COUNTRY_MO: 'Macao',
    COUNTRY_MP: 'Northern Mariana Islands',
    COUNTRY_MQ: 'Martinique',
    COUNTRY_MR: 'Mauritania',
    COUNTRY_MS: 'Montserrat',
    COUNTRY_MT: 'Malta',
    COUNTRY_MU: 'Mauritius',
    COUNTRY_MV: 'Maldives',
    COUNTRY_MW: 'Malawi',
    COUNTRY_MX: 'Mexico',
    COUNTRY_MY: 'Malaysia',
    COUNTRY_MZ: 'Mozambique',
    COUNTRY_NA: 'Namibia',
    COUNTRY_NC: 'New Caledonia',
    COUNTRY_NE: 'Niger',
    COUNTRY_NF: 'Norfolk Island',
    COUNTRY_NG: 'Nigeria',
    COUNTRY_NI: 'Nicaragua',
    COUNTRY_NL: 'Netherlands',
    COUNTRY_NO: 'Norway',
    COUNTRY_NP: 'Nepal',
    COUNTRY_NR: 'Nauru',
    COUNTRY_NU: 'Niue',
    COUNTRY_NZ: 'New Zealand',
    COUNTRY_OM: 'Oman',
    COUNTRY_PA: 'Panama',
    COUNTRY_PE: 'Peru',
    COUNTRY_PF: 'French Polynesia',
    COUNTRY_PG: 'Papua new Guinea',
    COUNTRY_PH: 'Philippines',
    COUNTRY_PK: 'Pakistan',
    COUNTRY_PL: 'Poland',
    COUNTRY_PM: 'St. Pierre and Miquelon',
    COUNTRY_PN: 'Pitcairn',
    COUNTRY_PR: 'Puerto Rico',
    COUNTRY_PS: 'Palestinian Territories',
    COUNTRY_PT: 'Portugal',
    COUNTRY_PW: 'Palau',
    COUNTRY_PY: 'Paraguay',
    COUNTRY_QA: 'Qatar',
    COUNTRY_RE: 'Reunion',
    COUNTRY_RO: 'Romania',
    COUNTRY_RS: 'Serbia',
    COUNTRY_RU: 'Russia',
    COUNTRY_RW: 'Rwanda',
    COUNTRY_SA: 'Saudi Arabia',
    COUNTRY_SB: 'Solomon Islands',
    COUNTRY_SC: 'Seychelles',
    COUNTRY_SD: 'Sudan',
    COUNTRY_SE: 'Sweden',
    COUNTRY_SG: 'Singapore',
    COUNTRY_SH: 'St. Helena',
    COUNTRY_SI: 'Slovenia',
    COUNTRY_SJ: 'Svalbard and Jan Mayen',
    COUNTRY_SK: 'Slovakia',
    COUNTRY_SL: 'Sierra Leone',
    COUNTRY_SM: 'San Marino',
    COUNTRY_SN: 'Senegal',
    COUNTRY_SO: 'Somalia',
    COUNTRY_SR: 'Surinam',
    COUNTRY_ST: 'Sao Tome and Principe',
    COUNTRY_SV: 'El Salvador',
    COUNTRY_SY: 'Syria',
    COUNTRY_SZ: 'Swaziland',
    COUNTRY_TA: 'Tristan da Cunha',
    COUNTRY_TC: 'Turks And Caicos Islands',
    COUNTRY_TD: 'Chad',
    COUNTRY_TF: 'French Southern Territories',
    COUNTRY_TG: 'Togo',
    COUNTRY_TH: 'Thailand',
    COUNTRY_TJ: 'Tajikistan',
    COUNTRY_TK: 'Tokelau',
    COUNTRY_TM: 'Turkmenistan',
    COUNTRY_TN: 'Tunisia',
    COUNTRY_TO: 'Tonga',
    COUNTRY_TP: 'East Timor',
    COUNTRY_TR: 'Turkey',
    COUNTRY_TT: 'Trinidad And Tobago',
    COUNTRY_TV: 'Tuvalu',
    COUNTRY_TW: 'Taiwan',
    COUNTRY_TZ: 'Tanzania',
    COUNTRY_UA: 'Ukraine',
    COUNTRY_UG: 'Uganda',
    COUNTRY_UK: 'United Kingdom',
    COUNTRY_UM: 'United States minor outlying islands',
    COUNTRY_US: 'United States of America',
    COUNTRY_UY: 'Uruguay',
    COUNTRY_UZ: 'Uzbekistan',
    COUNTRY_VA: 'Vatican City State (Holy See)',
    COUNTRY_VC: 'St. Vincent And The Grenadines',
    COUNTRY_VE: 'Venezuela',
    COUNTRY_VG: 'British Virgin Islands',
    COUNTRY_VI: 'Virgin Islands (USA)',
    COUNTRY_VN: 'Vietnam',
    COUNTRY_VU: 'Vanuatu',
    COUNTRY_WE: 'Western Samoa',
    COUNTRY_WF: 'Wallis and Futuna Islands',
    COUNTRY_WS: 'Samoa',
    COUNTRY_YE: 'Yemen',
    COUNTRY_YT: 'Mayotte',
    COUNTRY_ZA: 'South Africa',
    COUNTRY_ZM: 'Zambia',
    COUNTRY_ZW: 'Zimbabwe'
  },
  'ui-kit': uiKit,
  date: {
    today: 'Today',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    },
    monthsNumbered: {
      '01': uiKit.datepicker.january,
      '02': uiKit.datepicker.february,
      '03': uiKit.datepicker.march,
      '04': uiKit.datepicker.april,
      '05': uiKit.datepicker.may,
      '06': uiKit.datepicker.june,
      '07': uiKit.datepicker.july,
      '08': uiKit.datepicker.august,
      '09': uiKit.datepicker.september,
      10: uiKit.datepicker.october,
      11: uiKit.datepicker.november,
      12: uiKit.datepicker.december
    }
  }
};